import { EventTypes } from "../../../../types";
export const isSelectionNotFixture = (selection) => {
    return selection.eventType === EventTypes.Outright
        || selection.eventType === EventTypes.DayOfEventRace
        || selection.eventType === EventTypes.AntePostRace;
};
//# sourceMappingURL=isSelectionNotFixture.js.map